<section class="layout-pt-lg layout-pb-lg">
  <div class="container">
    <div class="row justify-center">
      <div class="col-lg-8">
        <h1 class="text-40 fw-700 text-dark-1 mb-40 text-center">Mesafeli Satış Sözleşmesi</h1>
        
        <div class="text-16 text-dark-1 lh-18">
          <p class="mb-30">
            İşbu sözleşme, Pusula Tatil üzerinden yapılan uzaktan satış işlemlerini düzenler. Alıcı, Pusula Tatil sitesinden yaptığı her türlü hizmet alımı için aşağıdaki şartları kabul etmiş sayılır.
          </p>

          <h4 class="text-20 fw-600 text-dark-1 mt-40 mb-20">1. Taraflar</h4>
          <p class="mb-30">
            <strong>Satıcı:</strong> Pusula Tatil<br>
            <strong>Alıcı:</strong> Hizmet satın alan kişi veya şirket
          </p>

          <h4 class="text-20 fw-600 text-dark-1 mt-40 mb-20">2. Hizmet Tanımı ve Fiyat</h4>
          <p class="mb-30">
            Satıcı, alıcıya belirttiği turizm hizmetlerini sağlayacaktır. Hizmetlerin fiyatı, sipariş sırasında belirtilen fiyat ile geçerlidir.
          </p>

          <h4 class="text-20 fw-600 text-dark-1 mt-40 mb-20">3. Ödeme Koşulları</h4>
          <p class="mb-30">
            Ödemeler, alıcı tarafından sitede belirtilen ödeme yöntemleriyle yapılacaktır. Satıcı, ödeme işlemini onaylamadan herhangi bir hizmeti sağlayamaz.
          </p>

          <h4 class="text-20 fw-600 text-dark-1 mt-40 mb-20">4. Tüketicinin Yasal Hakları</h4>
          <p class="mb-30">
            Alıcı, 14 gün içinde cayma hakkını kullanabilir. Ancak, turlar gibi bazı hizmetler için cayma hakkı sınırlı olabilir.
          </p>

          <h4 class="text-20 fw-600 text-dark-1 mt-40 mb-20">5. İptal ve İade</h4>
          <p class="mb-30">
            Satın alınan hizmetlerin iptal edilmesi halinde, iptal politikasına uygun olarak ücret iadesi yapılacaktır.
          </p>

          <div class="border-top-light pt-40 mt-60 text-center">
            <p class="text-light-1 text-15">
              Saygılarımızla,<br>
              Pusula Tatil Ekibi
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-newsletter></app-newsletter>
